export interface MFEConfig {
    qa: string;
    prod: string;
    next: string;
    dev: string;
}

const mfeConfig: MFEConfig = {
    qa: '@dev',
    prod: '@prod',
    next: '@next',
    dev: '@dev',
};

export function getMFELoaderUrl(env: string) {
    const mfeTag = mfeConfig[env.toLowerCase() as keyof MFEConfig] ?? mfeConfig.dev;

    return `https://unpkg.servicetitan.com/@servicetitan/fleet-admin-panel-mfe${mfeTag}`;
}
